import React, { useEffect, useRef, useState } from 'react';
import { DEFAULT_API_URL } from '../constents';
import uploadfiles from './handleUploadFiles';
import setUiMessage from './Tostify';
import Button from '../components/Button';

function CommonUploadFile({
  apiUri = '',
  handleUploadFile = () => null,
  lable = false,
  uploadBtn = false,
  uploadBtnLable = 'Upload',
  styleContainer = {},
  classNameContainer = '',
  buttonStyle,
  buttonVariant,
  fileUploadWraper,
  selectedFiles = [],
}) {
  const fileInputRef = useRef(null);
  const [finalFile, setFinalFile] = useState(selectedFiles || []);

  useEffect(() => {
    handleUploadFile(finalFile.map((item) => item?.fileName).join(','));
  }, [finalFile, handleUploadFile]);

  const handleFileSelect = async (e) => {
    const file = e?.target?.files?.[0] || fileInputRef.current?.files?.[0];
    if (file) {
      const apiUrl = `${DEFAULT_API_URL}/${apiUri}`;
      const response = await uploadfiles(apiUrl, file);
      if (fileInputRef.current) {
        fileInputRef.current.value = '';
      }
      if (response.data?.successCode === 'success') {
        setFinalFile((items) => [
          ...items,
          {
            fileName: response.data?.fileName,
            filePath: response.data?.flePathName,
          },
        ]);
      } else if (response.data?.successCode === 'error') {
        setUiMessage('err', response?.data?.msg);
      }
    } else {
      setUiMessage('err', 'Please select a file');
    }
  };

  const handleRemoveAttachFile = (index) => {
    const newAttachArr = [...finalFile];
    newAttachArr.splice(index, 1);
    setFinalFile(newAttachArr);
  };

  return (
    <div
      className={classNameContainer || 'grid-sec width100 responsive-container'}
      style={styleContainer}
    >
      <div className="flex-sec responsive-flex">
        {lable && (
          <label htmlFor="fileToUpload" className="com-atchmnt-lbl fontsize12">
            {lable}:
          </label>
        )}
        <div className={'file-upload-wrapper'} style={fileUploadWraper}>
          {uploadBtn ? (
            <>
              <input
                id="fileToUpload"
                type="file"
                className="com-atchmnt-file fontsize12"
                name="fileToUploadForReply"
                ref={fileInputRef}
                aria-label="Select file for upload"
              />
              <Button
                variant={buttonVariant || 'default'}
                onClick={handleFileSelect}
                style={buttonStyle}
              >
                {uploadBtnLable}
              </Button>
            </>
          ) : (
            <input
              id="fileToUpload"
              type="file"
              className="com-atchmnt-file fontsize12"
              name="fileToUploadForReply"
              onChange={handleFileSelect}
              ref={fileInputRef}
              aria-label="Select file for upload"
            />
          )}
        </div>
      </div>
      {finalFile.length > 0 && (
        <div className="com-atchd-file-sec flex-sec">
          <ol className="file-list">
            {finalFile.map((item, i) => (
              <li key={i} className="file-item">
                <span className="file-link">
                  <a
                    href={item?.filePath}
                    target="_blank"
                    rel="noreferrer noopener"
                    className="file-name"
                  >
                    {item?.fileName}
                  </a>
                </span>
                <button
                  type="button"
                  className="remove-file-btn"
                  onClick={() => handleRemoveAttachFile(i)}
                  aria-label={`Remove file ${item?.fileName}`}
                >
                  X
                </button>
              </li>
            ))}
          </ol>
        </div>
      )}
    </div>
  );
}

export default CommonUploadFile;
